import 'vuetify/src/stylus/app.styl';
import {
	Vuetify,
	VAlert,
	VApp,
	VAutocomplete,
	VBtn,
	VBtnToggle,
	VCard,
	VCheckbox,
	VChip,
	VDataIterator,
	VDatePicker,
	VDialog,
	VDivider,
	VForm,
	VGrid,
	VIcon,
	VList,
	VMenu,
	VNavigationDrawer,
	VRadioGroup,
	VSelect,
	VSlider,
	VSnackbar,
	VSubheader,
	VTextField,
	VTimePicker,
	VToolbar,
	VTooltip,
	transitions,
	VExpansionPanel,
	VDataTable,
	VProgressLinear,
	VProgressCircular,
	VTabs,
	VTextarea,
	VStepper,
	VSwitch,
	VTreeview,
	VAvatar,
	VInput,
	VPagination,
} from 'vuetify';

export default function (Vue) {
	Vue.use(
		Vuetify,
		{
			components: {
				VAvatar,
				VAlert,
				VApp,
				VAutocomplete,
				VBtn,
				VBtnToggle,
				VCheckbox,
				VChip,
				VCard,
				VDataIterator,
				VDatePicker,
				VDialog,
				VDivider,
				VForm,
				VGrid,
				VIcon,
				VInput,
				VList,
				VMenu,
				VNavigationDrawer,
				VRadioGroup,
				VSelect,
				VSlider,
				VSnackbar,
				VSubheader,
				VTextField,
				VTimePicker,
				VToolbar,
				VTooltip,
				transitions,
				VExpansionPanel,
				VDataTable,
				VProgressLinear,
				VProgressCircular,
				VTabs,
				VTextarea,
				VStepper,
				VSwitch,
				VTreeview,
				VPagination,
			},
			theme: JSON.parse(process.env.COLORS),
		},
	);
}



// WEBPACK FOOTER //
// ./src/vuetify.js